/**
 * PURPOSE: Cliente HTTP del idevent SISDEU de la "Ficha Auxiliar" desde Instituciones (FTR-0047).
 * RESPONSIBILITIES:
 * - Pedir al backend el idevent que recibe sismaster: el vínculo SISDEU activo del evento (event_external_ids)
 *   o, sin vínculo válido, el idchampionship de siempre. La regla vive en el backend.
 * - Rechazar una respuesta sin id válido, para no enviar a SISDEU un evento equivocado.
 * COLLABORATORS:
 * - InstitucionesArea.jsx
 * - backend GET /ficha-auxiliar/sisdeu-event/:idevent
 * ROUTE: src/area/InstitucionesArea/fichaAuxiliarService.js
 */

import axios from 'axios'
import API_BASE_URL from '../../config/config.js'

export async function getFichaAuxiliarSisdeuEventId(idevent) {
    const { data } = await axios.get(
        `${API_BASE_URL}/ficha-auxiliar/sisdeu-event/${encodeURIComponent(idevent)}`
    )
    const sisdeuEventId = Number(data?.sisdeuEventId)
    if (!Number.isInteger(sisdeuEventId) || sisdeuEventId <= 0) {
        throw new Error('El backend no devolvió un idevent SISDEU válido.')
    }
    return sisdeuEventId
}
